import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from 'store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export * from './useLocalStorage.hook';
export * from './usePasswordChecklist.hook';
export * from './useQuery.hook';
export * from './useTableScroll.hook';
export * from './useAdminParams';
export * from './useAdminFilter';
export * from './useIsInputWritable';
